const i = ["free", "premium", "pro", "enterprise"], r = ["meetings", "timeLimit", "integrations", "stream"], e = [
  "meetingMemory",
  "aiFeed",
  "recording",
  "integrations",
  "stream",
  "aiFeedLocal",
  "meetingSummary",
  "offTheRecord",
  "support"
], t = ["crm", "team", "meetingSharing"], n = {
  free: r,
  premium: e,
  pro: e,
  enterprise: t
};
export {
  n as planFeatures,
  i as planOrder
};
